module.exports = __webpack_public_path__ + "img/astral-txt_7.123632ca.svg";